/**
 * Generic superclass for visual stuff that can be inserted
 * into the Vizpan canvas.
 */
class Component {
    constructor(params) {
        this.fabricObject = null;
        this.parameters = params;
    }
    /**
     * Generates pixel-based fabric.js positional properties based on the
     * logical Vizpan properties, adjusted for pan and zoom.
     */
    generateBaseFabricOptions() {
        // Set the base properties first
        const fabricOptions = {
            selectable: false,
            left: this.vizpan.scale * this.parameters.x + this.vizpan.translateX,
            top: this.vizpan.scale * this.parameters.y + this.vizpan.translateY,
            width: this.parameters.width,
            height: this.parameters.height,
            scaleX: this.vizpan.scale,
            scaleY: this.vizpan.scale,
        };
        // Add any subclass-specific properties
        this.setAdditionalFabricOptions(fabricOptions);
        // Accont for any necessary adjustments for pan and zoom properties
        this.adjustForPanZoom(fabricOptions);
        return fabricOptions;
    }
    /**
     * Adds new, subclass-specific options to the internal Fabric object.
     * @param fabricOptions
     */
    // tslint:disable-next-line: no-empty
    setAdditionalFabricOptions(fabricOptions) { }
    /**
     * If necessary, modifiy the Fabric.js properties to account for variations in pan and zoom.
     * @param fabricProperties
     */
    // tslint:disable-next-line: no-empty
    adjustForPanZoom(fabricOptions) { }
    /**
     * Updates the existing internal Fabric.js object according to the component parameters.
     */
    updateFabricObject() {
        const fabricOptions = this.generateBaseFabricOptions();
        this.fabricObject.set(fabricOptions);
        this.adjustAngle();
    }
    /**
     * Helper method that adjusts the object rotation on its center.
     */
    adjustAngle() {
        if (this.parameters.angle !== undefined) {
            this.fabricObject.set('angle', undefined);
            this.fabricObject.rotate(this.parameters.angle);
        }
    }
}
/**
 * Generic geometric shape.
 */
class Shape extends Component {
    constructor(options) {
        super(options);
    }
    /**
     * Adds the Shape parameters to the Fabric options object
     * @param fabricOptions
     */
    setAdditionalFabricOptions(fabricOptions) {
        if (this.parameters.fill !== undefined)
            fabricOptions.fill = this.parameters.fill;
        if (this.parameters.stroke !== undefined)
            fabricOptions.stroke = this.parameters.stroke;
        if (this.parameters.strokeWidth !== undefined)
            fabricOptions.strokeWidth = this.parameters.strokeWidth;
    }
    /**
     * Creates a new object for a subclass of Shape
     */
    createFabricObject() {
        const fabricOptions = this.generateBaseFabricOptions();
        this.fabricObject = this.createSpecificFabricObject(fabricOptions);
        this.adjustAngle();
        this.vizpan.fabricCanvas.add(this.fabricObject);
    }
}
/**
 * A rectangle.
 */
class Rectangle extends Shape {
    createSpecificFabricObject(fabricProps) {
        return new fabric.Rect(fabricProps);
    }
}
/**
 * A triangle.
 */
class Triangle extends Shape {
    createSpecificFabricObject(fabricProps) {
        return new fabric.Triangle(fabricProps);
    }
}
/**
 * An ellipse
 */
class Ellipse extends Shape {
    createSpecificFabricObject(fabricProps) {
        return new fabric.Ellipse(fabricProps);
    }
    adjustForPanZoom(fabricProps) {
        const options = fabricProps;
        options.rx = options.width / 2;
        options.ry = options.height / 2;
    }
}
/**
 * An image
 */
class VizImage extends Component {
    constructor(options) {
        super(options);
    }
    /**
     * Creates the image component.
     */
    createFabricObject() {
        const outer = this;
        const fabricOptions = this.generateBaseFabricOptions();
        fabric.Image.fromURL(this.parameters.url, oImg => {
            oImg.set(fabricOptions);
            outer.fabricObject = oImg;
            outer.adjustAngle();
            outer.vizpan.fabricCanvas.add(oImg);
        });
    }
}
